import FavoriteTtiles from './favorite-tiles';

export default FavoriteTtiles;
